export function isFirefox(): boolean {
    return !!navigator?.userAgent.match(/Firefox/);
}
